import { render, staticRenderFns } from "./BigRobotCreate.vue?vue&type=template&id=b4e39ec8&scoped=true&"
import script from "./BigRobotCreate.vue?vue&type=script&lang=js&"
export * from "./BigRobotCreate.vue?vue&type=script&lang=js&"
import style0 from "./BigRobotCreate.vue?vue&type=style&index=0&id=b4e39ec8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e39ec8",
  null
  
)

export default component.exports